new MutationObserver(() => {
    fixAccessibility();
}).observe(document.body, { childList: true, subtree: true });

const fixAccessibility = () => {
    // Fix Dstillery pixels
    document.querySelectorAll('img[src*="action.dstillery.com"], img[src*="dstillery"]').forEach(pixel => {
        if (!pixel.hasAttribute('alt')) {
            pixel.setAttribute('alt', '');
        }
        if (!pixel.hasAttribute('aria-hidden')) {
            pixel.setAttribute('aria-hidden', 'true');
        }
    });
}

fixAccessibility();
